const EVENT_ACTIONS = {
  /**
   * This is the current version of the banner
   */
  BANNER_VERSION: 'banner-lib-version-5.1.2',
  /**
   * Dispatched when the banner is first loaded
   */
  CONSENT_BANNER_LOADED: 'consent-banner-loaded',
  /**
   * Dispatched when a user presses the accept all button
   */
  EXPLICIT_CONSENT_GIVEN: 'explicit-approval',
  /**
   * Dispatched when a user presses the refuse button
   */
  REFUSED_CONSENT: 'refused',
  /**
   * Dispatched when a user navigates to the consent page to manage settings
   */
  NAVIGATED_TO_CONSENT_PAGE: 'settings',
  /**
   * Dispatched when a post request to save the TCString was successful
   */
  POST_TC_STRING_SUCCESS: 'storeConsentSuccess',
  /**
   * Dispatched when a post request to save the TCString failed
   */
  POST_TC_STRING_FAILED: 'storeConsentFail',
  /**
   * Dispatched when postUserConsent threw an error
   */
  POST_TC_STRING_THREW_ERROR: 'storeConsentError',
};

export default EVENT_ACTIONS;
